// Plugins
import i18n from '@/plugins/i18n'

export default function() {
    let reportTypes = [];

    reportTypes.push({
        value: "make-up-exam",
        text: i18n.t("make_up_additional_student_list"),
        permission: "makeupexam_import",
    });

    reportTypes.push({
        value: "student-course",
        text: i18n.t("student_course"),
        permission: "studentcourse_import",
    });

    reportTypes.push({
        value: "courses-name-import",
        text: i18n.t("update_student_course_name"),
        permission: "studentcourse_update",
    });

    reportTypes.push({
        value: "student-course-delete",
        text: i18n.t("student_course_delete"),
        permission: "studentcourse_bulkdelete",
    });

    reportTypes.push({
        value: "student-semester-status-update",
        text: i18n.t("student_semester_status_update"),
        permission: "studentsemester_updatestudentsemesterstatus",
    });

    reportTypes.push({
        value: "bulk-student-slot-update",
        text: i18n.t("bulk_student_slot_update"),
        permission: "studentslot_studentslotexcelimport",
    });

    reportTypes.push({
        value: "bulk-student-add-permit",
        text: i18n.t("bulk_yoksis_freeze_registration_data_transfer"),
        permission: "yoksisservice_bulkaddpermit",
    });

    reportTypes.push({
        value: "bulk-student-semester-update",
        text: i18n.t("batch_course_term_information_update"),
        permission: "studentcourse_bulkstudentcoursesemesterupdateimport",
    });

    reportTypes.push({
        value: "bulk-delete-permit",
        text: i18n.t("bulk_delete_permit"),
        permission: "yoksisservice_bulkdeletepermit",
    });

    reportTypes.push({
        value: "bulk-course-name-import",
        text: i18n.t("update_student_bulk_course_name"),
        permission: "studentcourse_importcoursename",
    });

    reportTypes.push({
        value: "pilotage-invoice-import",
        text: i18n.t("pilotage_invoices"),
        permission: "pilotageinvoice_excelimport",
    });

    reportTypes.push({
        value: "payment-approval-exceptions-import",
        text: i18n.t("payment_approval_exceptions"),
        permission: "paymentapprovalexception_store",
    });

    reportTypes.push({
        value: "thesis-and-projects-import",
        text: i18n.t("collective_student_thesis_topic_determination"),
        permission: "thesisandproject_import",
    });

    reportTypes.push({
        value: "bulk-contact-information-update",
        text: i18n.t("bulk_contact_information_update"),
        permission: "student_updatepersonalinformationfromexcel",
    });

    reportTypes.push({
        value: "bulk-grading-system-update",
        text: i18n.t("bulk_grading_system_update"),
        permission: "studentcourse_bulkupdategradingsystem",
    });
    reportTypes.push({
        value: "updating-credits-and-ects",
        text: i18n.t("updating_credits_and_ects"),
        permission: "studentcourse_importstudentcoursecredit",
    });

    reportTypes.push({
        value: "person-data-import",
        text: i18n.t("person_data_import"),
        permission: "persondata_import",
    });

    reportTypes.push({
        value: "update-staff-expiration-date",
        text: i18n.t("update_staff_expiration_date"),
        permission: "staff_bulkupdatestaffexpirationdate",
    });

    reportTypes.push({
        value: "student-program-transfer",
        text: i18n.t("student_program_transfer"),
        permission: "studentprogram_programtransferexcelimport",
    });

    reportTypes.push({
        value: "rector-order-excel-import",
        text: i18n.t("rector_order_excel_import"),
        permission: "studentprogram_ministerrectororderexcelimport",
    });


    return reportTypes;

}


